module.exports = __webpack_public_path__ + "static/jonathan-agoot-serverless-computing-50408ea26353765a472b739c103f4b49.jpg";